import { Injectable } from "@angular/core";
import { Me, User } from "../../models/user";
import { FixedPhrase } from "../../models/fixedPhrase";
import { SearchParamsProvider } from "../../providers/search-params/search-params";
import { MasterData } from "../../models/master-data";
import { SearchParams } from "../../providers/user/user";

@Injectable()
export class TemplateProvider {
  searchParams: SearchParams;
  constructor(public searchParamsProvider: SearchParamsProvider) {
    this.getSerchParam();
  }

  setMaleTemplateList(femaleUser: User, me: Me): FixedPhrase[] {
    let templateList: FixedPhrase[];
    templateList = [
      {
        id: 0,
        title: "テンプレート1",
        user_id: femaleUser.id,
        message:
          femaleUser.getNickname() +
          "さん、はじめまして！\r\n" +
          me.getNickname() +
          "といいます。\r\nプロフィールを拝見して、気になったのでいいねしてみました！\r\nお話できたら嬉しいです。",
        order: 0,
        tempNo: 1,
      },

      {
        id: 1,
        title: "テンプレート2",
        user_id: femaleUser.id,
        message:
          "はじめまして！\r\n写真が素敵だったのでメッセージしました。\r\n仲良くなれたら嬉しいです、よろしくおねがいします！",
        order: 1,
        tempNo: 2,
      },
      {
        id: 2,
        title: "テンプレート3",
        user_id: femaleUser.id,
        message:
          "はじめまして、" +
          me.getNickname() +
          "といいます。\r\n" +
          this.getTemplateDateSentence(femaleUser) +
          "よかったらお話しましょう！",
        order: 2,
        tempNo: 3,
      },
      {
        id: 3,
        title: "テンプレート4",
        user_id: femaleUser.id,
        message:
          "はじめまして。\r\n" +
          this.getTemplateAppearanceSentence() +
          femaleUser.getNickname() +
          "さんがすごい好みで思わずメッセージしました！\r\nよかったら仲良くなりましょう！",
        order: 3,
        tempNo: 4,
      },
    ];
    return templateList;
  }

  private getTemplateDateSentence(femaleUser: User): string {
    if (femaleUser.getPurpose()) {
      return (
        "プロフィール見て、デートでしたいことの「" +
        femaleUser.getPurpose() +
        "」という条件が合いそうだなと思ってメッセージしました。\r\n"
      );
    }
    return "";
  }

  private getTemplateAppearanceSentence(): string {
    let looksesValue: {} = {};
    const masterData = MasterData.getData();
    looksesValue = masterData["lookses"];
    if (this.searchParams.lookses.length) {
      return (
        this.searchParams.lookses.map((v) => looksesValue[v]).join("、") +
        "の方がタイプなのですが、\r\n"
      );
    } else {
      return "";
    }
  }

  private getSerchParam(): void {
    this.searchParamsProvider.get().then(
      (data: SearchParams) => {
        if (data) {
          this.searchParams = data;
        } else {
          this.searchParams = this.searchParamsProvider.initialParams();
        }
      },
      (error) => {
        this.searchParams = this.searchParamsProvider.initialParams();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/template/template.ts